import QueryTimeslotGroups from 'graphql/queries/QueryTimeslotGroups'
import QueryTimeslotGroup from 'graphql/queries/QueryTimeslotGroup'
import GraphqlGroupedBuilder from 'utils/request/graphql/groupedBuilder'

export default class FetchTimeslotGroups
{
	static fetchAll( { callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) {
		GraphqlGroupedBuilder.addQuery( 'timeslot_groups', QueryTimeslotGroups, {
			resultPath: [ 'timeslot_groups' ],
			callbackStart,
			callbackError,
			callbackSuccess,
		})
	}
	
	static fetch( { guid = null, callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) {
		GraphqlGroupedBuilder.addQuery( 'timeslot_group', QueryTimeslotGroup, {
			variables: {
				guid: guid
			},
			resultPath: [ 'timeslot_group' ],
			callbackStart,
			callbackError,
			callbackSuccess,
		})
	}
}
